export default __webpack_public_path__ + "static/shop_closed-07ffbe9b7bd0e0088d0bb1b1443bf326.png";